export class Suggestion {
    email: string;
    field: string;
    label: string;
    suggestion: string;
    message: string;
    user: string;
    name: string;
}